import React, { useContext } from 'react';

import { ViewSettingsForm } from 'components/ChartTools';

import { GGChartContext } from '@gogame/components';
import { useScreenDispatch } from '@gogame/screens';

import { SET_CHART_VIEW_SETTINGS } from 'scenes/Trackers/Tracker/reducers';

import { useChartState, useChartIndex, useIsBreakdownMode } from '../hooks';

export const ViewSettingsAction = ({
  metrics,
  colorGetter,
  onChange,
  withPie = true,
}) => {
  const chartIndex = useChartIndex();
  const chartState = useChartState();
  const isChartBreakdownMode = useIsBreakdownMode();
  const dispatch = useScreenDispatch();
  const { count } = useContext(GGChartContext);

  //don't show brush control button
  const showBrushControl = count > 5;

  const handleChangeViewSettings = (value) => {
    dispatch({
      type: SET_CHART_VIEW_SETTINGS,
      payload: {
        index: chartIndex,
        value,
      },
    });
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <ViewSettingsForm
      showBrushControl={showBrushControl}
      initialValues={chartState.chartViewSettings}
      withStacked={isChartBreakdownMode}
      withPercentage={isChartBreakdownMode}
      breakdownMode={isChartBreakdownMode}
      disabledPie={!isChartBreakdownMode}
      metrics={metrics}
      colorGetter={colorGetter}
      withPie={withPie}
      withScatter={true}
      withLabel={true}
      withMixedType={true}
      onSubmit={handleChangeViewSettings}
    />
  );
};
